import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { laboratoryServices } from "../../../services";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  Drawer,
  SimpleToolbar,
  Loader,
  TextField,
  Toast,
} from "../../../components";
import {
  Grid,
  Container,
  makeStyles,
  Typography,
  Box,
  Divider,
  Button,
  IconButton,
  Paper,
  Switch,
  // TextField,
} from "@material-ui/core";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";

export default function UpdateZoneScreen() {
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [field, setField] = useState({ _id: "", name: "" });
  const { register, handleSubmit, errors, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [statusSwitch, setStatusSwitch] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const classes = useStyles();
  const history = useHistory();
  let { visitingZoneId } = useParams();

  const updateVisitingZone = async (data) => {
    const visitingZoneInfo = {
      ...field,
      status: statusSwitch ? "active" : "inactive",
      name: data.name,
    };
    try {
      setLoading(true);

      const { status, response } = await laboratoryServices.updateVisitingZone({
        visitingZoneInfo,
        token: authState.token,
      });
      setToast(true);
      setToastMessage(response.response.message);
      if (status === 200) {
        setTimeout(() => {
          history.replace("/zones");
        }, 500);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function getAVisitingZone() {
      setLoading(true);
      laboratoryServices
        .getAVisitingZone({
          visitingZoneId: visitingZoneId,
          token: authState.token,
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.response.response || { _id: "", name: "" };
            setField(data);
            setStatusSwitch(data.status === "active");
            reset({
              name: data.name,
            });
          } else {
            setToast(true);
            setToastMessage("Ha ocurrido un error.");
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setLoading(false));
    }
    getAVisitingZone();
  }, []);

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            <Paper className={classes.custom_paper}>
              <Box
                component="form"
                className={classes.form}
                onSubmit={handleSubmit(updateVisitingZone)}
              >
                <Box className={classes.container_fields}>
                  <Box
                    display="flex"
                    flexDirection={"column"}
                    style={{ gap: 12, marginTop: 16 }}
                  >
                    <Field
                      label="Nombre de zona"
                      placeholder="Zona..."
                      id={field._id}
                      name={`name`}
                      inputRef={register({
                        required: "Nombre de zona requerido",
                      })}
                      error={errors.name ? true : false}
                      helperText={errors.name ? errors.name.message : ""}
                    />
                    <Box
                      display="flex"
                      style={{ gap: 8, alignItems: "center" }}
                    >
                      <Switch
                        checked={statusSwitch}
                        onChange={(e) => setStatusSwitch(e.target.checked)}
                        name="status"
                      />
                      <Typography>
                        {statusSwitch ? "Activo" : "Inactivo"}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider
                    orientation="horizontal"
                    style={{ margin: "1rem 0" }}
                  />
                </Box>
                <Button
                  className={classes.submit_button}
                  color="primary"
                  variant="contained"
                  type="submit"
                  style={{ textTransform: "none" }}
                >
                  Guardar
                </Button>
              </Box>
            </Paper>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 24,
    paddingBottom: 24,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
  custom_paper: {
    padding: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1),
    },
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    overflow: "hidden",
    justifyContent: "space-between",
  },
  container_fields: {
    maxHeight: "55vh",
    overflowY: "auto",
    [theme.breakpoints.only("xs")]: {
      maxHeight: "65vh",
    },
  },
  submit_button: {
    boxShadow: `0 0 0 18px ${theme.palette.background.paper}`,
  },
}));

function Field(props) {
  const { id, label, placeholder, ...rest } = props;
  const cls = fieldStyles();
  return (
    <Box className={cls.container_field}>
      <Typography
        htmlFor={`input-${id}`}
        component="label"
        variant="body2"
        color="textPrimary"
      >
        {label}{" "}
      </Typography>
      <Box className={cls.field}>
        <TextField
          id={`input-${id}`}
          style={{ with: "100%" }}
          placeholder={placeholder}
          {...rest}
        />
      </Box>
    </Box>
  );
}

const fieldStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  container_field: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    width: "100%",
  },
  field: {
    display: "flex",
    alignItems: "stretch",
    position: "relative",
    height: 43,
    "& .MuiInput-root": {
      height: "100% !important",
      boxSizing: "border-box",
      fontSize: "0.8rem",
      "&.Mui-focused": {
        outlineOffset: `-1px `,
        outline: `1px solid ${theme.palette.warning.dark}`,
        border: "none",
      },
    },
    "& input::placeholder": {
      color: theme.palette.grey[600],
    },
  },
}));
